import { render, staticRenderFns } from "./Date2.vue?vue&type=template&id=affceba6&"
import script from "./Date2.vue?vue&type=script&lang=js&"
export * from "./Date2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports